import * as angular from "angular";
import {AccountModel} from "./angular/models/account.model";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozArray} from "../persistence-layer/bringoz-array";

angular
  .module('bringoz.admin.accounts')
  .factory('$accounts', AccountArrayFactory);

export type $accountsFactory = () => BringozArray<AccountModel>;

/* @ngInject */
function AccountArrayFactory($bringozFactory: $bringozFactory,
                             accountsAPI: BringozApi,
                             Accounts_DS: DataStoreConfig,
                             Accounts_PN: PushNotificationsConfig) {
  function $accounts() {
    return $bringozFactory<AccountModel>(null, accountsAPI, Accounts_DS, Accounts_PN);
  }

  return $accounts;
}
